export default __webpack_public_path__ + "static/media/Desktop view + map.232c1db1.png";